export default "/images/vendor/flag-icon-css/flags/4x3/br.svg?5ec13287c2da0d77a7e7d968528618ff";